import React from 'react';

function PresetCard({ preset, onActivate, onEdit, onDelete }) {
  return (
    <div className={`preset-card ${preset.is_active ? 'active' : ''}`}>
      <div className="preset-header">
        <div>
          <div className="preset-name">{preset.name}</div>
        </div>
        {preset.is_active && (
          <div className="preset-badge">Active</div>
        )}
      </div>

      <div className="preset-info">
        <div className="info-item">
          <span className="info-label">Name</span>
          <div className="info-value">{preset.first_name} {preset.last_name}</div>
        </div>
        <div className="info-item">
          <span className="info-label">Phone</span>
          <div className="info-value">{preset.phone}</div>
        </div>
      </div>

      <div className="preset-actions">
        {!preset.is_active && (
          <button 
            className="btn-small btn-activate"
            onClick={() => onActivate(preset.id)}
          >
            Activate
          </button>
        )}
        <button 
          className="btn-small btn-edit"
          onClick={() => onEdit(preset)}
        >
          Edit
        </button>
        <button 
          className="btn-small btn-delete"
          onClick={() => onDelete(preset.id)}
        >
          Delete
        </button>
      </div>
    </div>
  );
}

export default PresetCard;
